import { render } from "./HeaderMain.vue?vue&type=template&id=2172b60d&scoped=true"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=2172b60d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2172b60d"]])

export default __exports__